var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3562 14.1668H4.64312C4.42638 14.1668 4.25 14.0082 4.25 13.8127V3.18766C4.25 2.99216 4.42638 2.8335 4.64312 2.8335H8.5V5.06475C8.5 6.17825 9.36204 7.0835 10.4224 7.0835H12.75V13.8127C12.75 14.0082 12.5736 14.1668 12.3562 14.1668Z",
    fill: "#BEC3CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1262 5.72549L10.1685 1.19216C10.0304 1.03425 9.83556 0.944336 9.62983 0.944336H4.54101C3.51671 0.944336 2.68359 1.79207 2.68359 2.83322V14.1666C2.68359 15.2077 3.51671 16.0554 4.54101 16.0554H12.457C13.4813 16.0554 14.3152 15.2077 14.3152 14.1666V6.23322C14.3152 6.04509 14.2476 5.86451 14.1262 5.72549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49774 10.0111H6.31682C5.91553 10.0111 5.58984 9.67262 5.58984 9.25556C5.58984 8.83849 5.91553 8.5 6.31682 8.5H8.49774C8.89903 8.5 9.22471 8.83849 9.22471 9.25556C9.22471 9.67262 8.89903 10.0111 8.49774 10.0111ZM6.31682 11.522H10.6787C11.0807 11.522 11.4056 11.8604 11.4056 12.2775C11.4056 12.6946 11.0807 13.0331 10.6787 13.0331H6.31682C5.91553 13.0331 5.58984 12.6946 5.58984 12.2775C5.58984 11.8604 5.91553 11.522 6.31682 11.522Z",
    fill: "#E3282A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95312 3.19434L11.9465 5.47762H10.4722C10.1858 5.47762 9.95312 5.18976 9.95312 4.8354V3.19434Z",
    fill: "#E3282A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/prices.f8dd6e65741e0329a3e9749627b7c266.svg";
export { ForwardRef as ReactComponent };